import AdditionalTestingStore from "./AdditionalTestingStore"
import AuthStore from "./AuthStore"
import RegistrationStore from "./RegistrationStore"

export interface RootStore {
   authStore: AuthStore
   registrationStore: RegistrationStore,
   additionalTestingStore: AdditionalTestingStore
}

export const createRootStore = (): RootStore => {
  return {
    authStore: new AuthStore(),
    registrationStore: new RegistrationStore(),
    additionalTestingStore: new AdditionalTestingStore()
  }
}

export default createRootStore()